const FormResources = {

    form_data:{
        code:           '',
    },

    form_format:[
        {
            css_class:  'col-md-12',
            type:       'text',
            maxlength:  10,
            disabled:   false,
            step:       '',
            name:       'Code:',
            model_name: 'code',
            ref:        'code_input',
            ref_alt:    'code_input_alt',
            required:   true,
        },
    ],
    
}

export default FormResources;